export function EmojiFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm7 0a2 2 0 100-4 2 2 0 000 4zm6 0a2 2 0 100-4 2 2 0 000 4zm-7.199 2.095a1 1 0 011.331.479c.106.225.28.452.529.66.533.446 1.362.766 2.339.766.977 0 1.806-.32 2.34-.767.247-.207.422-.434.528-.66a1 1 0 011.809.853c-.245.52-.613.971-1.053 1.34C14.692 17.549 13.392 18 12 18s-2.692-.452-3.624-1.233a3.97 3.97 0 01-1.053-1.34 1 1 0 01.478-1.332z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
